import { _ } from '../utils.js'

export default class Share {
    constructor(el) {
        this.el = el
        this.trigger = _('share-trigger', 'element').nodeFrom(this.el)
        this.trigger.addEventListener('click', this.toggle)
    }

    toggle = () => {
        this.el.classList.toggle('share--closed')
        return false
    }
}
